module.exports = __webpack_public_path__ + "img/sun.eafa19dd.svg";